import { TFunction } from "react-i18next";
import { isValidPhoneNumber } from "react-phone-number-input";
import isEmail from "validator/lib/isEmail";
import * as yup from "yup";

import { FirstStepHandle } from ".";

export const validateFirstStep = (
  translate: TFunction<"translate", undefined>,
  validationObject: FirstStepHandle,
  callback: (error: yup.ValidationError[]) => void
) => {
  try {
    const schema = yup.object().shape({
      firstName: yup.string().required(translate("thisFieldIsRequired")),
      lastName: yup.string().required(translate("thisFieldIsRequired")),
      email: yup
        .string()
        .required(translate("thisFieldIsRequired"))
        .test({
          name: "validate-email",
          message: translate("thisEmailIsInvalid"),
          test: (value) => {
            return isEmail(value || "");
          },
        }),
      phone: yup
        .string()
        .required(translate("thisFieldIsRequired"))
        .test({
          name: "validate-phone",
          message: translate("pleaseEnterAValidPhoneNumber"),
          test: (value) => {
            return isValidPhoneNumber(value || "");
          },
        }),
    });

    schema.validateSync(
      validationObject,
      { abortEarly: false }
    );
    callback([]);

    return true;
  } catch (err) {
    if (err instanceof yup.ValidationError) {
      callback(err.inner);
    }

    return false;
  }
};
